import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { GENERAL_ROUTES, OLD_DASHBOARD_ROUTES } from "@src/routes/routes";

export const DashboardRoutes: RouteObject[] = [
  {
    path: `${OLD_DASHBOARD_ROUTES.Dashboard}/*`,
    element: <Navigate to={GENERAL_ROUTES.Index} />,
  },
];
